import API from 'utils/api';
import { onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';
import { store } from 'store';
import { message } from 'antd';

/**
 * GET Ciudadano para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCiudadanoCaja = async (params = null, allowFromOtherEntity = true) => {
  try {
    const { entidad } = store.getState().auth;
    const { ciudadano_publico_en_general } = entidad;
    const response = await API.get('/cuentaunicasir/ciudadano-caja/', { params });
    if (![200, 206].includes(response.status)) {
      message.info('No se encontraron coincidencias');
      return { results: [], count: 0 };
    }
    if ((response.data?.results || response.data)
      .some((e) => e.id === ciudadano_publico_en_general)) {
      message.info('El ciudadano publico en general no esta disponible en las búsquedas.');
      return false;
    }
    if (!Array.isArray(response.data)) {
      if ('results' in response.data) {
        if (response?.data?.results?.length) {
          const results = formatReceived(response.data.results.map((c) => ('clave_ciudadana' in c
            ? ({
              ...c,
              tipo_de_padron: 1,
              fromThisEntity: c.entidad.includes(entidad?.id),
            }) : ({ ...c, clave: c.clave_ciudadana }))));
          return { ...formatReceived(response.data), results };
        }
      } else {
        const matches = response.data.ciudadano.map((e) => ({
          ...e,
          fromThisEntity: e.entidad.includes(entidad?.id),
        }));
        return matches.filter((e) => (allowFromOtherEntity ? e : e.fromThisEntity));
      }
    }
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [], count: 0 };
  }
};

/**
 * POST Obtener todos los cargos del ciudadano inclyendo todos los padrones que le pertenezcan
 * @param {object} values
 * @returns {Promise<Array<object>>}
 */
export const postConsultarCargosCiudadanos = async (values) => {
  try {
    const response = await API.post('/cuentaunicasir/consulta-caja-atencion-ciudadana/', values);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Obtener pdf de obligaciones
 * @param {number} padron_id
 * @param {number} tipo_de_padron
 * @returns {Promise<Object>}
 */
export const postImprimirObligaciones = async (padron_id, tipo_de_padron) => {
  try {
    const response = await API.post('/cuentaunicasir/opinion-de-las-obligaciones/pdf/', {
      padron_id,
      tipo_de_padron,
    });
    const base64 = `data:application/pdf;base64,${response.data.data}`;
    return { base64, success: true };
  } catch (err) {
    onError(err);
    return { success: false };
  }
};

/**
 * POST Obtener pdf de obligaciones
 * @param {number} amount
 * @param {date} fecha
 * @param {number} cargos
 * @param {number} padron_id
 * @param {number} tipo_de_padron
 * @param {number} importe
 * @returns {Promise<Object>}
 */
export const postImprimirOrdenDePago = async (
  amount,
  fecha,
  fechaBilling,
  cargos,
  padron_id,
  tipo_de_padron,
  _ciudadano,
  referencia_normal,
  extra = {},
  convenio = null,
  descuentos = [],
  observaciones_complemento,
  otro_formato = false,
  es_traslado = false,
  orden_anual = false,
) => {
  try {
    const observacioesExtra = 'Antes de realizar el pago, favor de asegurarse de que la información presentada y los cargos sean correctos, ya que no habrá devoluciones posteriores.';
    const ciudadano = _ciudadano || store.getState().entidad?.ciudadano_publico_en_general || null;
    const response = await API.post('/recaudacion/referencias-pago-netpay/', {
      amount,
      description: '-',
      paymentMethod: 'cash',
      currency: 'MXN',
      ciudadano,
      billing: {
        cargos,
        padron_id,
        tipo_de_padron,
        ciudadano,
        importe: amount,
        fecha: fechaBilling,
        merchantReferenceCode: null,
        observaciones_complemento: observaciones_complemento ?? observacioesExtra,
        ...extra,
        referencia_normal: !otro_formato,
        descuentos,
        otro_formato,
        es_traslado,
        orden_anual,
      },
      convenio,
      expiryDate: fecha,
      idPadron: tipo_de_padron,
    }, { accionInf: 'ORDEN_DE_PAGO_CAJA' });
    const base64 = `data:application/pdf;base64,${response.data.data}`;
    return {
      folio: response.data.folio,
      base64,
      success: true,
    };
  } catch (err) {
    onError(err);
    return { success: false };
  }
};
